import template from './verify-account.html';
import './verify-account.styl';

function verifyAccountController($state, $stateParams, $tszToast, AuthService) {

  'ngInject';

  this.loading = true;

  const email = $stateParams.e;
  const token = $stateParams.t;

  AuthService.verifyAccount(email, token)
  .then(() => {
    // validation succeeded: redirect to the default page
    console.log('Email validated!');
    // $tszToast.showSuccess('Su correo electrónico ha sido validado. Ya puede iniciar sesión.');
    const params = {
      obj: {
        status: 'EMAIL_VALIDATED',
        toast: {
          message: 'Su correo electrónico ha sido validado. Ya puede iniciar sesión.',
          opts: { success: true },
        },
        email,
      },
    };
    $state.go('login', params);
  }).catch((err) => {
    // login error
    $tszToast.showError(`Lo sentimos. Su cuenta no ha podido ser validada: ${err}`);
  }).finally(() => {
    // regardless of the response, change the loading state
    this.loading = false;
  });
}

export default {
  template,
  controller: verifyAccountController,
};



// WEBPACK FOOTER //
// ./src/containers/verify-account/index.js